<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  /* *{outline:1px solid blue;} */
</style>



// WEBPACK FOOTER //
// src/App.vue